export default __webpack_public_path__ + "static/media/Linkedin Learning HTML Essential Training.5eb829ba.webp";